// Development environment
export const ENV_DEVELOPMENT_ID = "development";
export const ENV_DEVELOPMENT_TITLE = "Development";
export const ENV_DEVELOPMENT_DOMAIN_PREFIX = "dev";
// Production environment
export const ENV_PRODUCTION_ID = "production";
export const ENV_PRODUCTION_TITLE = "Production";
export const ENV_PRODUCTION_DOMAIN_PREFIX = "";
// UAT environment
export const ENV_UAT_ID = "uat";
export const ENV_UAT_TITLE = "UAT";
export const ENV_UAT_DOMAIN_PREFIX = "uat";
// Local environment
export const ENV_LOCAL_ID = "local";
export const ENV_LOCAL_TITLE = "Local";
export const ENV_LOCAL_DOMAIN_PREFIX = "dev";
// Staging environment
export const ENV_STAGING_ID = "staging";
export const ENV_STAGING_TITLE = "Staging";
export const ENV_STAGING_DOMAIN_PREFIX = "staging";
export const ENVIRONMENTS = {
    [ENV_DEVELOPMENT_ID]: {
        id: ENV_DEVELOPMENT_ID,
        title: ENV_DEVELOPMENT_TITLE,
        domainPrefix: ENV_DEVELOPMENT_DOMAIN_PREFIX,
    },
    [ENV_PRODUCTION_ID]: {
        id: ENV_PRODUCTION_ID,
        title: ENV_PRODUCTION_TITLE,
        domainPrefix: ENV_PRODUCTION_DOMAIN_PREFIX,
    },
    [ENV_UAT_ID]: {
        id: ENV_UAT_ID,
        title: ENV_UAT_TITLE,
        domainPrefix: ENV_UAT_DOMAIN_PREFIX,
    },
    [ENV_LOCAL_ID]: {
        id: ENV_LOCAL_ID,
        title: ENV_LOCAL_TITLE,
        domainPrefix: ENV_LOCAL_DOMAIN_PREFIX,
    },
    [ENV_STAGING_ID]: {
        id: ENV_STAGING_ID,
        title: ENV_STAGING_TITLE,
        domainPrefix: ENV_STAGING_DOMAIN_PREFIX,
    },
};
